<script>
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import CpSmall from '@/assets/images/cp-small.png'
export default {
  extends: BaseModal,
  data: function () {
    return { CpSmall }
  }
}
</script>

<template lang="pug">
span
  .modal-header
  .modal-body
    .row.mb-5
      .col.col-lg-8.offset-lg-2
        .mb-5
          span.mr-2 Uprzejmie informujemy, że przez moduł można nadawać
          span.mr-2.font-weight-bold tylko i wyłącznie przesyłki kurierskie.
        .mb-2 Wszystkie pozostałe przesyłki i dokumenty prosimy pozostawiać w odpowiednio do tego przeznaczonych skrytkach w strefie obsługi pracownika.

    .row.mb-5
      .col.col-lg-3.offset-lg-9.text-left
        .mb-2 Dziękujemy!
        .mb-2 Zespół Administracji

  .modal-footer.fixed
    .row.h-100
      .col-12.col-lg-4.offset-lg-4.h-100.d-flex.align-items-center
        button.btn.btn-primary.btn-block(type="button" v-ea-click="() => {close(true)}") Rozumiem
</template>

<style lang="scss" scoped></style>
